"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var DataHelper_1 = require("./DataHelper");
var RequestHelper_1 = require("./RequestHelper");
/**
 * Сервис, предоставляющий методы для отправки событий в Clickhouse API.
 */
var Service = /** @class */ (function () {
    /**
     * Создаёт экземпляр сервиса с указанной конфигурацией.
     * @param config Объект конфигурации сервиса.
     */
    function Service(config) {
        if (config === void 0) { config = {}; }
        this.config = config;
    }
    /**
     * Заполняет недостающие параметры указанного события значениями по
     * умолчанию.
     * @param event Событие.
     */
    Service.prototype.assignDefaults = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            function isNotExists(key) {
                return !Object.prototype.hasOwnProperty.call(event, key);
            }
            var _a, isUtmNotExists, search;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.sessionId = DataHelper_1.default.getSessionId(event.logout);
                        if (isNotExists('deviceId')) {
                            event.deviceId = DataHelper_1.default.getDeviceId();
                        }
                        if (isNotExists('userAgent')) {
                            event.userAgent = DataHelper_1.default.getUserAgent();
                        }
                        if (isNotExists('referrer')) {
                            event.referrer = DataHelper_1.default.getReferrer();
                        }
                        if (isNotExists('screenHeight')) {
                            event.screenHeight = DataHelper_1.default.getScreenHeight();
                        }
                        if (isNotExists('screenWidth')) {
                            event.screenWidth = DataHelper_1.default.getScreenWidth();
                        }
                        if (!isNotExists('isIncognito')) return [3 /*break*/, 2];
                        _a = event;
                        return [4 /*yield*/, DataHelper_1.default.getIsIncognito()];
                    case 1:
                        _a.isIncognito = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (isNotExists('time')) {
                            event.time = DataHelper_1.default.getTime();
                        }
                        if (isNotExists('timezone')) {
                            event.timezone = DataHelper_1.default.getTimeZone();
                        }
                        if (isNotExists('href')) {
                            event.href = DataHelper_1.default.getHref();
                        }
                        isUtmNotExists = isNotExists('utmCampaign') &&
                            isNotExists('utmContent') &&
                            isNotExists('utmSource') &&
                            isNotExists('utmMedium') &&
                            isNotExists('utmTerm');
                        if (isUtmNotExists) {
                            search = DataHelper_1.default.getSearch();
                            event.utmCampaign = search['utm_campaign'];
                            event.utmContent = search['utm_content'];
                            event.utmSource = search['utm_source'];
                            event.utmMedium = search['utm_medium'];
                            event.utmTerm = search['utm_term'];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Вызывает пользовательский хук `beforeAssignDefaults` из конфигурации
     * сервиса для указанного события.
     * @param event Событие.
     */
    Service.prototype.beforeAssignDefaults = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.beforeAssignDefaults) return [3 /*break*/, 2];
                        result = this.config.beforeAssignDefaults(event);
                        return [4 /*yield*/, Promise.resolve(result)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Вызывает пользовательский хук `beforeSend` из конфигурации сервиса для
     * указанного события.
     * @param event Событие.
     */
    Service.prototype.beforeSend = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.beforeSend) return [3 /*break*/, 2];
                        result = this.config.beforeSend(event);
                        return [4 /*yield*/, Promise.resolve(result)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Возвращает коллекцию заголовков запроса к API, полученную из указанного
     * события.
     * @param event Событие.
     */
    Service.prototype.getHeaders = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                return [2 /*return*/, RequestHelper_1.default.createHeaders((_a = {},
                        _a["Content-Type"] = 'application/json',
                        _a["Accept"] = 'application/json',
                        _a["User-Agent"] = event.userAgent,
                        _a["X-UserID"] = event.userId,
                        _a["X-API-KEY"] = this.config.id || undefined,
                        _a["X-API-CLIENT-ID"] = this.config.clientId || undefined,
                        _a["X-SessionID"] = event.sessionId,
                        _a))];
            });
        });
    };
    /**
     * Возвращает тело запроса к API, полученное на основе указанного события.
     * @param event Событие.
     */
    Service.prototype.getBody = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, RequestHelper_1.default.createBody({
                        event: event.name,
                        eventValue: event.payload,
                        fingerprintID: event.deviceId,
                        referer: event.referrer,
                        source: event.utmSource,
                        campaign: event.utmCampaign,
                        medium: event.utmMedium,
                        content: event.utmContent,
                        term: event.utmTerm,
                        screenHeight: event.screenHeight,
                        screenWidth: event.screenWidth,
                        isIncognito: event.isIncognito,
                        localTime: RequestHelper_1.default.formatTime(event.time),
                        testGroup: event.testGroup,
                        timeZone: RequestHelper_1.default.formatTimezone(event.timezone),
                        page: event.href,
                        operator: event.operator,
                        userType: event.userType,
                    })];
            });
        });
    };
    /**
     * Если сервис подключён к API, отправляет указанное событие на сервер. В
     * противном случае не делает ничего.
     * @param event Событие.
     */
    Service.prototype.fetch = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.url || !this.config.id || !this.config.clientId) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getHeaders(event)];
                    case 1:
                        headers = _a.sent();
                        return [4 /*yield*/, this.getBody(event)];
                    case 2:
                        body = _a.sent();
                        return [4 /*yield*/, fetch(this.config.url, {
                                headers: headers,
                                body: body,
                                method: 'post',
                                mode: 'cors',
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Если в конфигурации сервиса указан флаг `verbose`, логгирует указанное
     * событие. В противном случае не делает ничего.
     * @param event Событие.
     */
    Service.prototype.log = function (event) {
        if (!this.config.verbose || typeof console === 'undefined') {
            return;
        }
        console.debug('clickhouse_event', event);
    };
    /**
     * Отправляет указанное событие в Clickhouse API.
     * @param name Название события.
     * @param params Параметры события.
     */
    Service.prototype.send = function (name, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event = __assign({ name: name }, params);
                        return [4 /*yield*/, this.beforeAssignDefaults(event)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.assignDefaults(event)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.beforeSend(event)];
                    case 3:
                        _a.sent();
                        this.log(event);
                        return [4 /*yield*/, this.fetch(event)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Отправляет событие `visit` в Clickhouse API. Событие сингнализирует о
     * начале визита пользователя на сайт. Реальная отправка данного события
     * происходит только после начала браузерной сессии. Все последующие вызовы
     * метода ни к чему не приведут.
     *
     * Рекомендуется отправлять данное событие при `DOMContentLoaded` или первой
     * отрисовке приложения (если мы говорим о SPA).
     * @param params Параметры события.
     */
    Service.prototype.sendVisit = function (params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var visitId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        visitId = DataHelper_1.default.getVisitId();
                        if (visitId) {
                            return [2 /*return*/];
                        }
                        DataHelper_1.default.setVisitId();
                        return [4 /*yield*/, this.send('visit', params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Service;
}());
exports.default = Service;
